export const defaultPipelineJobName = 'Job 1'
export const defaultPipelineJobId = 'Job1'
export const defaultPipelineJobAgent = 'Linux-Medium'
